import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleContinentMultiple extends TitleBase {
	protected canHandle(): boolean {
		return this.multiValueFilters.length >= 1 && this.multiValueFilters.some((_) => _.type === ParameterType.CONTINENT);
	}

	protected getPageTitle(): string {
		return `${this.titlePortalType} in selected continents`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(this.titlePortalType, ' in selected continents');
	}
}
